
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

 try {
 	window.$ = window.jQuery = require('jquery');
 } catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
 // slick



import 'toastr/toastr.js';



require(['lightgallery.js/dist/js/lightgallery.js' , 'lg-zoom.js/dist/lg-zoom.js' , 'lg-thumbnail.js/dist/lg-thumbnail.js' ], function() {

	lightGallery(document.getElementById('lightgallery'), {
		selector: 'a',
		thumbnail:true,
		animateThumb: false,
		showThumbByDefault: true,
		zoom: true,
		scale : 1,
		thumbContHeight: 40,
		thumbWidth : 40,
		mode: "lg-zoom-in",

	});
});
 window._ = require('lodash');
 window.Popper = require('popper.js').default;


 window.axios = require('axios');

 window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

 let token = document.head.querySelector('meta[name="csrf-token"]');

 if (token) {
 	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
 } else {
 	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
 }

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */


// import Echo from 'laravel-echo'
// window.io = require('socket.io-client');
// // window.Pusher = require('pusher-js');

// window.Echo = new Echo({
// 	broadcaster: 'socket.io',
// 	host: window.location.hostname + ':6001'
// });



// WEBPACK FOOTER //
// ./resources/assets/js/front/bulma.js